/* TODO: t() */
import React, { useEffect, useState } from 'react';

import NumberInput from './NumberInput';

// TODO: Combine this with CurrencyInput
export default function AmountInput(props: {
  amount: number;
  onChange: (amount: number) => void;
}) {
  const { amount, onChange } = props;
  const [isFocused, setFocused] = useState(false);
  // Note we use state for the current string that is being typed. We update it
  // with the formatted version of the amount prop only in the following
  // situations:
  // - At initialization
  // - When the input loses focus
  // - When the amount prop changes and the input does not currently have focus
  const [input, setInput] = useState(() => formatAmount(amount));
  useEffect(() => {
    if (!isFocused) {
      setInput(formatAmount(amount));
    }
  }, [isFocused, amount]);
  return (
    <NumberInput
      leftIcon="dollar"
      value={input}
      onFocus={() => {
        setFocused(true);
      }}
      onBlur={() => {
        setInput(formatAmount(amount));
        setFocused(false);
      }}
      onValueChange={(valueAsNumber, valueAsString) => {
        onChange(valueAsNumber);
        setInput(valueAsString);
      }}
    />
  );
}

function formatAmount(amount: number) {
  // Display as an integer if no decimal part, else round to two decimal places.
  // TODO: The preferred number of decimal places is locale/currency specific.
  return amount.toFixed(Number.isInteger(amount) ? 0 : 2);
}
